import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const InvoiceViewContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "InvoiceViewContainer" */
      './InvoiceViewContainer.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
